import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { deleteFolder } from '@widgets/Files/api/deleteFolder';
import { handleStatusError } from '@widgets/Files/helpers/handleStatusError';

export const useDeleteFolder = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation({
        mutationKey: ['deleteFolder'],
        mutationFn: deleteFolder,
        onSuccess: (data) => {
            handleStatusError(data, t('useFileUpload.return.swal.manyFiles.button'));
            if (data.status === 'success') {
                queryClient.invalidateQueries({ queryKey: ['files'] });
            }
        },
    });
};
